import React from 'react';
import { ActivityHistory } from './ActivityHistory';
import './CyclingTab.css';

interface CyclingTabProps {
  refreshTrigger: number;
  isConnected: boolean;
  isSyncing: boolean;
  onDryRun: () => void;
  onSync: () => void;
}

export const CyclingTab: React.FC<CyclingTabProps> = ({ refreshTrigger, isConnected, isSyncing, onDryRun, onSync }) => {
  return (
    <div className="cycling-tab">
      <div className="cycling-tab__actions">
        <button
          onClick={onDryRun}
          disabled={!isConnected || isSyncing}
          className="cycling-tab__button cycling-tab__button--secondary"
          title={!isConnected ? 'Connect all services to enable syncing' : 'Run a dry run to check for duplicates'}
        >
          <span className="cycling-tab__button-icon">🔍</span>
          <span className="cycling-tab__button-text">Dry Run</span>
        </button>

        <button
          onClick={onSync}
          disabled={!isConnected || isSyncing}
          className="cycling-tab__button cycling-tab__button--primary"
          title={!isConnected ? 'Connect all services to enable syncing' : 'Sync files to Garmin Connect'}
        >
          <span className="cycling-tab__button-icon">{isSyncing ? '⏳' : '🚀'}</span>
          <span className="cycling-tab__button-text">{isSyncing ? 'Syncing...' : 'Sync'}</span>
        </button>
      </div>

      <ActivityHistory refreshTrigger={refreshTrigger} />
    </div>
  );
};
